/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listenToInbox = /* GraphQL */ `
  subscription ListenToInbox($inboxOwner: String!) {
    listenToInbox(inboxOwner: $inboxOwner) {
      senderSub
      recipientSub
      inboxOwner
      sentAt
      status
      messageInBase64
      price
      isPurchased
      __typename
    }
  }
`;
